import { ComponentProps, FC } from 'react';
import { useField } from 'formik';
import styles from './FormField.module.css';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';
import { AutoExpandTextArea } from '../AutoExpandTextArea';
import { Input } from '../TextField/views';
import { Select } from '../Select';

type FormFieldProps = {
  component: typeof AutoExpandTextArea | typeof Input | typeof Select;
  name: string;
  label?: string;
  id?: string;
  required?: boolean;
};

export const FormField = <T extends FC = FC>({
  component: Component,
  id,
  label,
  ...props
}: ComponentProps<T> & FormFieldProps) => {
  const [field, { touched, error }] = useField(props.name);

  const node = (
    <>
      <Component
        id={id}
        {...field}
        {...props}
        className={clsx(styles.input, (props as any).className)}
        error={touched && Boolean(error)}
      />
      {error && touched && (
        <sup className={styles.error}>
          <FormattedMessage id={error} />
        </sup>
      )}
    </>
  );

  if (!label) return node;

  return (
    <label
      htmlFor={id}
      className={clsx(styles.label, { [styles.error]: error && touched })}
    >
      <span>
        {label}:
        {(props as any).required && <sup className={styles.asterisk}>*</sup>}
      </span>
      {node}
    </label>
  );
};
